<template>
	<v-card 
		class="elevation-8 pt-10 pb-10 pl-5 pr-5"
	>
		<v-img 
			height="90" 
			contain 
			src="@/assets/logo.jpeg"
		>
			
		</v-img>
		<v-card-title
			class="font-weight-black justify-center"
		>
		{{form_title}}
		</v-card-title>
		<v-card-subtitle
			class="font-weight-black text-center mt-0"
		>
		{{form_subtitle}}
		</v-card-subtitle>

		<v-card-text>
			<v-text-field
				prepend-icon="mdi-email"
				name="login"
				:label="account_label_text"
				type="text"
				v-model="account"
				@keyup.enter="signIn"
			></v-text-field>
			<v-text-field
				id="password"
				prepend-icon="mdi-lock"
				name="password"
				:label="password_label_text"
				type="password"
				v-model="password"
				@keyup.enter="signIn"
			></v-text-field>
			<span
				class="grey--text lighten-3 clickable forget-hover"
				@click="goForgetPwd"
			>
				忘記密碼?
			</span>				
		</v-card-text>
		<v-card-actions
			class="justify-center"
		>
			<v-btn
				outlined
				color="#ee5e58"
				class="pl-10 pr-10"
				@click="signIn"
			>
				{{form_action_btn_text}}
			</v-btn>
		</v-card-actions>						
	</v-card>
</template>
<script>
import {
	apiLogin
} from '@/api/admin.js'

	export default {
		name: 'SignIn',
		components: {
		},
		created: function() {
			this.initPage()
		},
		mounted: function() {
			console.log(process.env.VUE_APP_MODE)
			console.log(process.env.VUE_APP_API_ENDPOINT)
		},
		data: function() {
			return {
				// 登入視窗標題
				form_title: '',

				// 登入視窗副標題
				form_subtitle: '',

				// 帳號的數值
				account: '',

				// 帳號輸入框的標題文字
				account_label_text: '', 

				// 密碼的數值
				password: '',

				// 密碼輸入框的標題文字
				password_label_text: '',

				// 登入按鈕的文字
				form_action_btn_text: '',
		
			}
		},
		methods: {
            /**
             * 2022/1/2 created by Watson
             *
             * function description:
             * 初始化頁面參數
             *
             * @return {none}
            */			
			initPage: function() {
				this.form_title           = 'Optimize99'
				this.form_subtitle        = '管理後台'
				this.account              = ''
				this.account_label_text   = '信箱'
				this.password             = ''
				this.password_label_text  = '密碼'
				this.form_action_btn_text = '登入'
			},			
            /**
             * 2022/1/2 created by Watson
             *
             * function description:
             * 登入功能
             *
             * @return {none}
            */ 			
			signIn: async function() {
				// console.log('isLogin',this.$store.state.isLogged)
				// this.$store.commit('login')
				// console.log('isLogin',this.$store.state.isLogged)
				// this.$router.push('/organization')

				if (!this.account) {
					this.$root.vtoast.show({
						message: '請輸入帳號'
					})

					return
				}

				if (!this.password) {
					this.$root.vtoast.show({
						message: '請輸入密碼'
					})
					return
				}

				console.log('帳號:', this.account)
				console.log('密碼:', this.password)
				let that = this
				let result = null
				result = await apiLogin({
					email: this.account,
					password:this.password
				}).then(function(resp){
					let data = resp.data.data
					console.log('login_data',data)
					return data

				}).catch(function(error){
					console.log(error)

					if (error.response) {
						that.$root.vtoast.show({
							message: "帳號密碼輸入錯誤"
						})
						return null
					}

					that.$root.vtoast.show({
						message: error
					})

					return null
				})
				
				if (result) {
					this.$root.vtoast.show({
						message: "登入成功！"
					})
					localStorage.setItem('authorization_token',result.token)
					this.$router.push('/home')
					this.$store.commit('setLoginInfo',result)
				}

			},
			goForgetPwd: function(){
				this.$router.push('/forget_password')
			}
		}
	};
</script>
<style>
	.clickable{
		cursor: pointer;
	}
</style>